import gql from 'graphql-tag';
import { sortBy } from 'lodash';
import { ApolloClient } from '@apollo/client';
import { CourseTypeFragment } from './__queries__';
import { Item } from '@baemingo/table-events/dist/types';

interface ExtendedTableItem extends Item {
  count?: number;
  courseType?: CourseTypeFragment;
}

export const sortByCourseTypeOrder = (
  items: ExtendedTableItem[],
  client: ApolloClient<object>,
) => {
  return sortBy(
    items.map((i) => {
      if (!i.courseId) {
        return i;
      }

      const courseType = client.readFragment<CourseTypeFragment>({
        id: i.courseId,
        fragment: gql`
          fragment CourseTypeFragment on CourseType {
            id
            color
            label
            order
            name
          }
        `,
      });

      if (!courseType) {
        return i;
      }

      return {
        ...i,
        courseType,
      };
    }),
    [({ courseType }) => courseType?.order || Infinity],
  );
};
